import * as customerManager from '$domain/model/customer/customer.manager'
import * as sessionManager from '$domain/model/session/session.manager'

export const registerAndLoginCustomer = async loginRegisterInfo => {
  const sessionData = await customerManager.registerAndLoginCustomer(loginRegisterInfo)
  sessionManager.createSession(sessionData)
}



// WEBPACK FOOTER //
// ./src/services/customer/registerLogin/registerLogin.service.ts